import { ReactNode, useEffect } from 'react';

import { ThemeProvider } from '@material-ui/core';

import {
  encoreDarkTheme,
  encoreLightTheme,
} from '@spotify/confidence-backstage-encore-theme';

import { useBUITheme } from './useBUITheme';

const ENCORE_CLASSES = ['encore-layout-themes', 'encore-medium-devices-theme'];

function useEncoreTheme(themeMode: 'light' | 'dark') {
  useEffect(() => {
    const colorClass = `encore-${themeMode}-theme`;
    const allClasses = [...ENCORE_CLASSES, colorClass];

    document.body.setAttribute('data-theme-variant', 'encore');
    document.body.classList.add(...allClasses);

    return () => {
      document.body.removeAttribute('data-theme-variant');
      document.body.classList.remove(...allClasses);
    };
  }, [themeMode]);
}

export const EncoreDarkThemeProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  useBUITheme('dark');
  useEncoreTheme('dark');

  return <ThemeProvider theme={encoreDarkTheme}>{children}</ThemeProvider>;
};

export const EncoreLightThemeProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  useBUITheme('light');
  useEncoreTheme('light');

  return <ThemeProvider theme={encoreLightTheme}>{children}</ThemeProvider>;
};
